import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

export type ButtonVariant = 'default' | 'primary';

@Component({
  selector: 'app-az-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './az-button.component.html',
  styleUrl: './az-button.component.scss',
})
export class AzButtonComponent {
  @Input() label: string = '';
  @Input() icon: string = '';
  @Input() iconPosition: 'left' | 'right' = 'left';
  @Input() showIcon: boolean = true;
  @Input() variant: ButtonVariant = 'default';
  @Input() disabled: boolean = false;
}
